import Vue from "vue";
import VueRouter from "vue-router";
import Products from "../views/ProductList.vue";
import ProductCreate from "../views/ProductCreate.vue";
import ProductUpdate from "../views/ProductUpdate.vue";
import Categories from "../views/CategoryList.vue";
import CategoryCreate from "../views/CategoryCreate.vue";
import CategoryUpdate from "../views/CategoryUpdate.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Products",
    component: Products,
  },
  {
    path: "/products/create",
    name: "ProductCreate",
    component: ProductCreate,
  },
  {
    path: "/products/update/:id",
    name: "ProductUpdate",
    component: ProductUpdate,
  },{
    path: "/categories",
    name: "Categories",
    component: Categories,
  },
  {
    path: "/categories/create",
    name: "CategoryCreate",
    component: CategoryCreate,
  },
  {
    path: "/categories/update/:id",
    name: "CategoryUpdate",
    component: CategoryUpdate,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
